/**
 * List of game tags used for different components.
 */
export enum Tags {
  /**
   * The player, or the character the player is currently controlling
   */
  PLAYER = 'player',
  /**
   * The smaller circle the player is chasing/looking for
   */
  KID = 'kid',

  /**
   * Other circles
   */
  NPC = 'npc',
  /**
   * Entities that are unmoving and the player cannot go thru,
   * used for map boundaries
   */
  WALL = 'wall',
}
